import {
  createMassPayUser,
  deleteWithdrawalMethod,
  fetchMassPayActivationUrl,
  fetchMassPayCountries,
  fetchWithdrawals,
  requestWithdrawal,
} from './asyncThunks';

export const fetchWithdrawalsBuilder = builder => {
  builder.addCase(fetchWithdrawals.pending, state => {
    state.fetchWithdrawalsInfo.pending = true;
  });
  builder.addCase(fetchWithdrawals.fulfilled, (state, { payload }) => {
    const { data, total } = payload;
    state.fetchWithdrawalsInfo.pending = false;
    state.fetchWithdrawalsInfo.data = data;
    state.fetchWithdrawalsInfo.total = total;
  });
  builder.addCase(fetchWithdrawals.rejected, state => {
    state.fetchWithdrawalsInfo.pending = false;
  });
};

export const requestWithdrawalBuilder = builder => {
  builder.addCase(requestWithdrawal.pending, state => {
    state.pending.requestWithdrawal = true;
  });
  builder.addCase(requestWithdrawal.fulfilled, (state, { payload }) => {
    state.pending.requestWithdrawal = false;
  });
  builder.addCase(requestWithdrawal.rejected, state => {
    state.pending.requestWithdrawal = false;
  });
};

export const deleteWithdrawalMethodBuilder = builder => {
  builder.addCase(deleteWithdrawalMethod.pending, state => {
    state.pending.deleteWithdrawalMethod = true;
  });
  builder.addCase(deleteWithdrawalMethod.fulfilled, state => {
    state.pending.deleteWithdrawalMethod = false;
  });
  builder.addCase(deleteWithdrawalMethod.rejected, state => {
    state.pending.deleteWithdrawalMethod = false;
  });
};

export const createMassPayUserBuilder = builder => {
  builder.addCase(createMassPayUser.pending, state => {
    state.pending.createMassPayUser = true;
  });
  builder.addCase(createMassPayUser.fulfilled, state => {
    state.pending.createMassPayUser = false;
  });
  builder.addCase(createMassPayUser.rejected, state => {
    state.pending.createMassPayUser = false;
  });
};

export const fetchMassPayActivationUrlBuilder = builder => {
  builder.addCase(fetchMassPayActivationUrl.pending, state => {
    state.pending.fetchMassPayActivationUrl = true;
  });
  builder.addCase(fetchMassPayActivationUrl.fulfilled, state => {
    state.pending.fetchMassPayActivationUrl = false;
  });
  builder.addCase(fetchMassPayActivationUrl.rejected, state => {
    state.pending.fetchMassPayActivationUrl = false;
  });
};

export const fetchMassPayCountriesBuilder = builder => {
  builder.addCase(fetchMassPayCountries.fulfilled, (state, { payload }) => {
    state.massPayCountries = payload.countries;
  });
};
